import { Box } from '@mantine/core';
import type React from 'react';

interface Props {
	size: number;
	variant?: 'black' | 'white';
}

const logoColor = {
	black: '#222222',
	white: '#FCFCFC',
} as const;

export const TFLogo: React.FC<Props> = ({ size, variant = 'black' }) => {
	const fill = logoColor[variant];

	return (
		<Box w={size} h={size}>
			<svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path fillRule="evenodd" clipRule="evenodd" d="M1.28901e-05 0H7.99992V8H1.28901e-05V0Z" fill={fill} />
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M7.99993 16L7.99992 8H15.9998L23.9998 16H15.9998V24L7.99993 16Z"
					fill={fill}
				/>
				<path fillRule="evenodd" clipRule="evenodd" d="M15.9998 0H24V8L15.9998 0Z" fill={fill} />
			</svg>
		</Box>
	);
};
